import { FrequencyKind } from '../recurrence.rule';
import { RecurrenceError, RecurrenceErrorCodes } from '../recurrence.errors';
import { OccurrenceGenerator } from './occurrence.generator';
import { RRuleGenerator } from './rrule.generator';
import { CustomGenerator } from './custom.generator';
import { EventGenerator } from './event.generator';

/**
 * Wire kind → strategy. Adding a new frequency = one new generator + one entry here.
 * Open/Closed Principle: zero changes to picker, service, or any consumer.
 */
export class OccurrenceGeneratorFactory {
  private static readonly registry: Readonly<Record<FrequencyKind, OccurrenceGenerator>> = Object.freeze({
    event: new EventGenerator(),
    custom: new CustomGenerator(),
    daily: new RRuleGenerator(),
    weekly: new RRuleGenerator(),
    biweekly: new RRuleGenerator(),
    monthly: new RRuleGenerator(),
    last: new RRuleGenerator(),
  });

  static for(kind: FrequencyKind): OccurrenceGenerator {
    const gen = OccurrenceGeneratorFactory.registry[kind];
    if (!gen) {
      throw new RecurrenceError(
        `No generator registered for kind=${kind}`,
        RecurrenceErrorCodes.GENERATOR_NOT_FOUND,
      );
    }
    return gen;
  }
}
